<template>
  <div>
    <Navigation/>
    <div class="bg_box">
      <div class="noneBox"></div>
      <div class="box">
        <p class="back" @click="$router.push('/wordNav')">返回</p>

        <div class="ct_box flex">
          <div class="form_upload_box">
            <ai_title ai_title="“智能生成”_AI策划方案"/>
            <select_model @getModelStyle="getModelStyle"></select_model>
            <p class="from_title_new">生成策划方案</p>

            <div class="transparent_box">
              <ai_select selectTitle="所属行业" :select_list="industry_list" @getSelectVal="get_industry"/>
              <div class="form_ct flex">
                <p class="upLoad_text">公司名称：</p>
                <div class="upload_box">
                  <el-input v-model="form.corporate_name" placeholder="请录入公司名称"></el-input>
                </div>
              </div>
              <div class="form_ct flex">
                <p class="upLoad_text">活动主题：</p>
                <div class="upload_box">
                  <el-input v-model="form.activity_theme"
                            placeholder="请录入预活动策划的具体主题。如：人工智能聊天app、音乐喷泉"></el-input>
                </div>
              </div>
              <ai_button_file_data ref="ai_button_file_data" @file_data="file_data"/>
              <ai_text_content :contentData="contentData"/>
            </div>

          </div>
          <wordNav/>
          <aiNum title="计费规则：1000tokens = 0.9元，" text="1000tokens在700-750字左右" :visible="aiNumShow"
                 @close="aiNumShow = false" @postData="postData"/>
          <aiPoup :visible="aiPoupShow" @close="aiPoupShow = false"/>
        </div>
      </div>
    </div>
    <footerBot/>
  </div>
</template>

<script>
import wordNav from '@/components/wordNav.vue'
import ai_select from '@/components/ai_select'
import ai_title from '@/components/ai_title'
import ai_text_content from '@/components/ai_text_content'
import ai_button_file_data from '@/components/ai_button_file_data'
import select_model from "@/components/select_model.vue";

export default {
  mounted() {
    this.getUserInfo()
  },
  components: {
    select_model,
    ai_title,
    wordNav,
    ai_select,
    ai_text_content,
    ai_button_file_data
  },
  data() {
    return {
      // 模型选择
      model_style: 1,
      form: {
        industry: '',
        corporate_name: '',
        activity_theme: '',
      },
      industry_list: [
        {
          id: '科技',
          name: '科技'
        },
        {
          id: '教育',
          name: '教育'
        },
        {
          id: '党政党建',
          name: '党政党建'
        },
        {
          id: '餐饮美食',
          name: '餐饮美食'
        },
        {
          id: '金融理财',
          name: '金融理财'
        },
        {
          id: '体育运动',
          name: '体育运动'
        },
        {
          id: '家具装修',
          name: '家具装修'
        },
        {
          id: '旅游旅行',
          name: '旅游旅行'
        },
        {
          id: '医学医疗',
          name: '医学医疗'
        },
        {
          id: '汽车交通',
          name: '汽车交通'
        },
        {
          id: '工业',
          name: '工业'
        },
        {
          id: '美容',
          name: '美容'
        },
        {
          id: '房地产',
          name: '房地产'
        },

      ],
      contentData: {}, //内容
      selectList: ['美食', '自然', '专题', '历史', '生活', '宣传', '其他'],
      aiNumShow: false,
      aiPoupShow: false,

    }
  },
  methods: {
    getModelStyle(data) {
      this.model_style = data
    },
    get_industry(val) {
      this.form.industry = val
    },
    // 获取用户信息
    getUserInfo() {
      let $user_info = JSON.parse(localStorage.getItem('user_info'))
      if ($user_info) {
        this.curlGet('/api/user/info').then((res) => {
          if (res.data.code) {
            this.$user_info = res.data.data
            this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage
          }
        })
      }
    },
    file_data() {
      if (this.model_style === 1) {
        this.postData()
        return
      }
      // if (this.form.type == '') {
      //     return this.$message({
      //         message: '请输入从事行业',
      //         type: 'warning',
      //         offset: 80,
      //     });
      // }
      // if (this.form.business == '') {
      //     return this.$message({
      //         message: '请输入标题',
      //         type: 'warning',
      //         offset: 80,
      //     });
      // }
      // if (this.form.keyword == '') {
      //     return this.$message({
      //         message: '请输入关键字',
      //         type: 'warning',
      //         offset: 80,
      //     });
      // }
      if (this.$user_info.money <= 0) {
        this.aiPoupShow = true
      } else {
        this.aiNumShow = true
      }

    },
    postData() {
      this.aiNumShow = false
      this.$refs.ai_button_file_data.loading_show()
      this.curlPost('/file/create_activities', {
        industry: this.form.industry,
        corporate_name: this.form.corporate_name,
        activity_theme: this.form.activity_theme,
        mobile: this.$user_info.mobile,
        model_style: this.model_style
      }).then(res => {
        this.$refs.ai_button_file_data.loading_show()
        if (res.data.code) {
          this.contentData = res.data.data
          // 扣费
          this.curlPost('/api/users/money_log/spend', {
            ai_id: res.data.data.id,
            amount: res.data.data.money,
          }).then(res => {
            if (res.data.code) {
              this.getUserInfo()

            }
          })
        } else {
          this.$message.error(res.data.msg);
        }
      })
    }
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/ai'
</style>